import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=41d276f2&"
import script from "./Trends.vue?vue&type=script&lang=ts&"
export * from "./Trends.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports